import React from "react";
import { TextInput, TextInputProps } from "@mantine/core";

export function ETextInput({ ...props }: TextInputProps) {
  return (
    <TextInput
      labelProps={{ className: "mb-1 text-sm", style: { fontSize: "14px" } }}
      radius={"md"}
      size="md"
      {...props}
    />
  );
}
